// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"41700703","408":"f51f1476","468":"44056eae","725":"14a0aacc","787":"6a2d597e","844":"8cab1204","873":"9c063673","952":"f7c9b1e4"}[chunkId] + ".chunk.js";
};